<template>
  <el-dialog
    class="zy-dialog"
    :title="title"
    :fullscreen="fullScreen"
    :visible.sync="visible"
	  :show-close="showClose"
	  :top="top"
    @close="onCloseHanlder"
  >
    <template #title>
      <slot name="title"></slot>
    </template>
    <template>
      <slot></slot>
    </template>
    <template #footer>
      <slot name="footer"></slot>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: "zyDialog",
  props: {
    top: {
      type: String,
      default: "15vh",
    },
    fullScreen: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    showDialog: {
      type: Boolean,
      default: false,
    },
    showClose: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      visible: false,
    };
  },
  watch: {
    showDialog(value) {
      this.visible = value;
    },
  },
  methods: {
    onCloseHanlder() {
      this.$emit("close", true);
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-dialog__headerbtn {
  top: 10px;
  right: 10px;
}
</style>
